<style src="./ColumnItem.scss" lang="scss" scoped></style>
<template>
  <li
    :class="{ 'notquoted': !(info.itemQuoted && info.itemQuoted.proposalPrice > 0) }"
    class="result-column-item box">
    <div class="id">
      <span
        v-if="!!info.itemInfo.lot"
        class="labellot">{{ info.itemInfo.lot }}</span>
      <span class="labelitem">{{ info.itemInfo.number }}</span>
    </div>

    <div class="product">
      <span class="description">{{ info.itemInfo.description }}</span>
      <div class="count">
        <span
          v-if="info.itemInfo && info.itemInfo.strictToME"
          class="strict-to-me stricttome"
          title="Exclusivo para Micro Empresa">
          ME
        </span>
        <div
        v-if="info.itemQuoted && info.itemQuoted.isPriceGuaranted"
          class="symbol guaranted"
          title="Item com garantia de preço">
          <icon-star class="icon" />
        </div>

        <span class="label" title="Quantidade"><small>x</small> {{ info.itemInfo.quantity | DecimalNumber}}</span>
        <span class="label" title="Fator"><small>x</small> {{ info.itemInfo.factor | DecimalNumber}}</span>
        <span class="label cost" title="Custo cotado"><small>R$</small> {{ info.itemQuoted.quotePrice | CurrencyBR}}</span>
        <span class="label unity" title="Unidade">{{ info.itemInfo.unity }}</span>
      </div>
    </div>

    <div class="proposal" v-if="!(info.itemQuoted && info.itemQuoted.proposalPrice > 0)">
      <span class="noprice">NÃO COTADO</span>
    </div>
    <div class="proposal" v-if="(info.itemQuoted && info.itemQuoted.proposalPrice > 0)">
      <span class="title">PROPOSTA</span>
      <span class="price">
        <small class="prefix">R$ </small>
        {{ (info.itemQuoted && info.itemQuoted.proposalPrice) | CurrencyBR }}
        <small class="suffix"> {{ calculateProposalPerc(info)}}%</small>
      </span>
      <div class="minimum">
        <span class="label">MÍN</span>
        <span class="value"><small>R$</small> {{ (info.itemQuoted && info.itemQuoted.minimumPrice) | CurrencyBR }}</span>
        <span class="perc">{{ calculateMinimumPerc(info) }}%</span>
      </div>
      <span class="lab" title="Marca da proposta">
        {{ info.itemQuoted && info.itemQuoted.quotedLab }}
      </span>
    </div>
  </li>
</template>

<script>
import { DecimalNumber, CurrencyBR } from '@/components/primitives/helpers/filters'
import { IconStar, IconLockGliph } from '@/components/primitives/icons'

export default {
  name: 'ColumnItem',
  components: {
    IconStar,
    IconLockGliph
  },
  props: {
    info: {
      type: Object,
      default: null
    }
  },
  filters: {
    DecimalNumber,
    CurrencyBR
  },
  methods: {
    calculateProposalPerc (info) {
      const v1 = info.itemQuoted && info.itemQuoted.proposalPrice
      const v2 = info.itemQuoted && info.itemQuoted.quotePrice

      const r = ((v1 * 100) / v2) - 100
      return !isNaN(r) ? r.toFixed() : ''
    },
    calculateMinimumPerc (info) {
      const v1 = info.itemQuoted && info.itemQuoted.minimumPrice
      const v2 = info.itemQuoted && info.itemQuoted.quotePrice

      const r = ((v1 * 100) / v2) - 100
      return !isNaN(r) ? r.toFixed() : ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/event-result/components/column-item/ColumnItem.vue